import { render, staticRenderFns } from "./AdditiveEdit.vue?vue&type=template&id=2771bac8&scoped=true"
import script from "./AdditiveEdit.vue?vue&type=script&lang=js"
export * from "./AdditiveEdit.vue?vue&type=script&lang=js"
import style0 from "./AdditiveEdit.vue?vue&type=style&index=0&id=2771bac8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2771bac8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2771bac8')) {
      api.createRecord('2771bac8', component.options)
    } else {
      api.reload('2771bac8', component.options)
    }
    module.hot.accept("./AdditiveEdit.vue?vue&type=template&id=2771bac8&scoped=true", function () {
      api.rerender('2771bac8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods_activity/additive/AdditiveEdit.vue"
export default component.exports